var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQrcode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 13.3333V0H13.8333V13.3333H0.5ZM5.5 5V8.33333H8.83333V5H5.5Z",
    fill: "#393939"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.166 13.3333V0H30.4993V13.3333H17.166ZM22.166 5V8.33333H25.4993V5H22.166Z",
    fill: "#393939"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 16.667V30.0003H13.8333V16.667H0.5ZM8.83333 21.667V25.0003H5.5V21.667H8.83333Z",
    fill: "#393939"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.166 16.667H17.166V20.0003H22.166V26.667H20.4993V23.3337H17.166V30.0003H23.8327V26.667H27.166V30.0003H30.4993V25.0003H27.166V23.3337H25.4993V21.667H30.4993V16.667H25.4993V20.0003H22.166V16.667Z",
    fill: "#393939"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrcode);
export default __webpack_public_path__ + "static/media/qrcode.ed1f56ac6c3d851fc256b33c9af7d88a.svg";
export { ForwardRef as ReactComponent };